// extracted by mini-css-extract-plugin
module.exports = {"checkbox-slider":"checkbox-slider-18JjMhd"};